import React from 'react';

export default _ => <tr><td colspan={12}>Nenhum registro encontrado para os filtros utilizados</td></tr>
